module.exports = __webpack_public_path__ + "static/media/logo-green.20036344.svg";